import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
/* Store Custom Code - End */

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    // Store Removed Code - searchMenuWrapper
    // Store Removed Code - linkListHidden
    // Store Custom Code
    logoGridItem: InjectableCss;
    navGridItem: InjectableCss;
    navWrapper: InjectableCss;
    mobileHeaderSignIn: InjectableCss;
    searchHiddenWrapper: InjectableCss;
    searchWrapper: InjectableCss;
    cartWrapper: InjectableCss;
    cartGridItem: InjectableCss;
    searchItem: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    /* Store Custom Code - Start */
    container: {
        css: css`
            position: relative;
            display: flex;
            height: 100px;
            justify-content: space-between;
            align-items: center;
            padding: 15px 0;

            > div {
                align-items: center;
                flex-wrap: nowrap !important;
            }

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            height: 75px;
                            max-width: 100% !important;
                            padding-left: 15px;
                            padding-right: 15px;
                        `,
                        null,
                        css`
                            padding-left: 0;
                            padding-right: 0;
                        `,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoGridItem: {
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-right: 0;
                            padding-left: 36px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            margin: 0;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin: 0;
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            css`
                                height: 47px;
                                width: 132px;
                                margin: 0;
                            `,
                            css`
                                height: 47px;
                                width: 132px;
                                margin: 0;
                            `,
                            null,
                            null,
                            css`
                                height: 68px;
                                width: 185px;
                                margin: 0;
                            `,
                        ],
                        "min",
                    );
                }}
            }
        `,
    },
    navGridItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: flex;
                            text-align: right;
                            margin-left: auto !important;
                        `,
                        css`
                            margin-left: auto !important;
                            max-width: 70px;
                            padding: 0;
                            text-align: right;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    navWrapper: {
        css: css`
            text-align: right;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css``,
                        css`
                            width: 40px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    mobileHeaderSignIn: {
        css: css`
            text-align: right;

            button {
                width: 35px;
                height: 50px;
                margin: 0;

                > span,
                > span > svg {
                    height: 26px;
                    width: 26px;
                    margin: auto;
                }
            }
        `,
    },
    searchHiddenWrapper: {
        css: css`
            text-align: right;
            width: 100% !important;
        `,
    },
    searchWrapper: {
        css: css`
            text-align: right;
            width: 100%;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css``,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    cartGridItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            min-width: 40px;
                            padding: 0;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    cartWrapper: {
        css: css`
            text-align: right;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            min-width: 40px;
                            max-width: 40px;

                            svg {
                                height: 24px;
                                width: 24px;
                                margin: auto;
                            }
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    searchItem: {
        css: css`
            width: 100%;
            padding-right: 16px;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        null,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    /* Store Custom Code - End */
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    /* Store Custom Code - Start */
    <StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.container}>
            <StyledWrapper {...logoLinksSearchStyles.logoGridItem}>
                <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
                    <Zone contentId={id} zoneName="Logo" />
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.navGridItem}>
                <StyledWrapper {...logoLinksSearchStyles.navWrapper}>
                    <Zone contentId={id} zoneName="SiteNavigation" />
                </StyledWrapper>
                <Hidden above="sm" {...logoLinksSearchStyles.mobileHeaderSignIn}>
                    <Zone contentId={id} zoneName="MobileHeaderSignIn" />
                </Hidden>
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.searchItem}>
                <Hidden below="md" {...logoLinksSearchStyles.searchHiddenWrapper}>
                    <StyledWrapper {...logoLinksSearchStyles.searchWrapper}>
                        <Zone contentId={id} zoneName="Search" />
                    </StyledWrapper>
                </Hidden>
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.cartGridItem}>
                <StyledWrapper {...logoLinksSearchStyles.cartWrapper}>
                    <Zone contentId={id} zoneName="Cart" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    </StyledWrapper>
    /* Store Custom Code - End */
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
